import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { useBetterAuthForCurrentPlatform } from '@et/guards';

/**
 * Native dual-auth bearer bridge: keep both strategies registered while
 * iOS/Android choose Better Auth vs AAD from Profile `GET /public/auth`.
 *
 * That probe is anonymous and must not trigger MSAL login while the native
 * shell is still learning which provider to use.
 */
@Injectable()
export class DualAuthInterceptor implements HttpInterceptor {
  private readonly msalInterceptor = inject(MsalInterceptor);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.includes('/public/auth') ||
      useBetterAuthForCurrentPlatform()
    ) {
      return next.handle(request);
    }
    return this.msalInterceptor.intercept(request, next);
  }
}
